export const UTILS__FILE_READER__get_uint8_array = file => {
    return new Promise(resolve => {
        const reader = new FileReader()
        reader.onload = evt => {
            const result = evt.target.result
            const array = new Uint8Array(result)
            if (!array.length) {
                resolve({
                    error: true,
                    code: 1,
                })
            }
            // const binary_string = String.fromCharCode.apply(null, array);
            resolve({
                error: false,
                result: array,
            })
        }
        reader.onerror = err => {
            resolve({
                error: true,
            })
        }
        reader.readAsArrayBuffer(file)
    })
}

export const UTILS__FILE_READER__GET_DECODED = file => {
    return new Promise(resolve => {
        const reader = new FileReader()
        reader.onload = evt => {
            const result = evt.target.result
            resolve({
                error: false,
                result,
            })
        }
        reader.onerror = err => {
            resolve({
                error: true,
            })
        }
        reader.readAsDataURL(file)
    })
}

export const UTILS__CONVERT_DATA_URI_TO_BINARY = dataURI => {
    const BASE64_MARKER = ';base64,'
    const base64Index = dataURI.indexOf(BASE64_MARKER) + BASE64_MARKER.length
    const base64 = dataURI.substring(base64Index)
    const raw = window.atob(base64)
    const rawLength = raw.length
    const array = new Uint8Array(new ArrayBuffer(rawLength))

    for (let i = 0; i < rawLength; i++) {
        array[i] = raw.charCodeAt(i)
    }
    return array
}
